import { createSlice } from "@reduxjs/toolkit";

const initialState = { reportFilter: [{id: Date.now(), field: '', operator: '', value: ''}], };

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        setReportFilter: (state, action) => {
            state.reportFilter = action.payload;
        },
        clearReportFilter: (state) => {
            state.reportFilter = [{ id: Date.now(), field: "", operator: "", value: "" }]; // Reset to initial state
        },
    },
});

export const { setReportFilter, clearReportFilter } = reportSlice.actions;
export default reportSlice.reducer;